module.exports = __webpack_public_path__ + "assets/img/mecha-9f6bfd61.png";